import { providerLogger } from '@ragu-components/logger';
import { buildUrl, maybeThrowHttpError } from '@ragu-components/ord-providers';

import type { AxiosInstance } from 'axios';

export const getApTemplateDefaults = async (
  axiosInstance: AxiosInstance,
  realmId: string
): Promise<Record<string, string>> => {
  providerLogger.debug('getApTemplateDefaults');
  const url = buildUrl('ap_templates/defaults', { realmId });
  const response = await axiosInstance.get(url);
  maybeThrowHttpError(response);
  return response.data;
};
